import Vue from 'vue'
import App from './App.vue'
import store from './store';

Vue.config.productionTip = false

Vue.prototype.$roundUpToHundreds = function(value) {
  return Math.ceil(value / 100) * 100;
};

new Vue({
  store,
  render: h => h(App),
}).$mount('#app')
